export default __webpack_public_path__ + "static/media/sobemesaespecial.494c02f3.png";